export const CUSTOMER_LOG_ROUTES_V822 = {
  ordinary: '/log',
  special: '/organization-log',
  customer: '/vertex-log/customer',
  legacy: '/vertex-log',
  googleDiagnostics: '/provider-log/google',
};

export const CUSTOMER_LOG_NAVIGATION_V822 = [
  {
    name: 'customer_logs_v822.ordinary',
    to: CUSTOMER_LOG_ROUTES_V822.ordinary,
    icon: 'book',
    authenticated: true,
  },
  {
    name: 'customer_logs_v822.special',
    to: CUSTOMER_LOG_ROUTES_V822.special,
    icon: 'building outline',
    authenticated: true,
    root: true,
  },
];

export const resolvePortalNavigationV811 = (buttons, portalProfile, root) => {
  if (root) return buttons;
  const visibleButtons = buttons.filter((button) => !button.root);
  if (portalProfile !== 'vertex_only') return visibleButtons;
  return visibleButtons.map((button) => {
    if (button.to === CUSTOMER_LOG_ROUTES_V822.ordinary) {
      return {
        ...button,
        name: 'customer_logs_v822.special',
        to: CUSTOMER_LOG_ROUTES_V822.customer,
        icon: 'building outline',
      };
    }
    if (button.to === '/dashboard') {
      return { ...button, name: 'header.vertex_dashboard' };
    }
    return button;
  });
};
